<template lang="pug">
  spreadsheet(:opts='user_opts')
</template>

<script>
export default {
  data() {
    return {
      registeration: {
        show: false,
        url: '',
        title: '',
      },
      user_opts: {
        tableName: 'users',
        displayName: '用户',
        columns: [
          {
            label: 'account',
          },
          {
            label: '业绩目标',
          },
          {
            label: '业绩完成',
          },
          {
            label: '电话',
            displayLabel: '电话(天)',
          },
          {
            label: '推荐',
            displayLabel: '推荐(周)',
          },
          {
            label: '面试',
            displayLabel: '面试(周)',
          },
          {
            label: 'LIST',
            displayLabel: 'LIST(月)',
          },
          {
            label: 'offer',
            displayLabel: 'offer(月)',
          },
          {
            label: '到岗',
            displayLabel: '到岗(月)',
          },
          {
            label: '变动',
            displayLabel: '变动(周)',
          },
          {
            label: 'BD-Leads',
            displayLabel: 'BD-Leads(周)',
          },
          {
            label: '会面',
            displayLabel: '会面(周)',
          },
          {
            label: '线人',
            displayLabel: '线人(周)',
          },
          {
            label: 'Mapping',
            displayLabel: 'Mapping(周)',
          },
          {
            label: '薪酬',
            displayLabel: '薪酬(周)',
          },
          {
            // ,
            //   label: 'BD-Leads完成'
            label: '会面完成',
          },
          {
            label: '线人完成',
          },
          {
            label: 'Mapping完成',
          },
          {
            label: '薪酬完成',
          },
          {
            label: '过程未完成累计',
          },
          {
            label: '过程完成率',
          },
          {
            label: '结果完成',
          },
        ],
        defaultItem: {
          permissions: {
            所有人: '读写',
          },
        },
        maxItem: 1000,
        showPagination: true,
        expandable: true,
        actionbar: false,
        creatable: false,
        trackable: true,
        update: (data, label, value) =>
          app
            .service('users')
            .patch(data._id, {
              [`${label}`]: value,
            })
            .then(() => {
              if (data.account === app.user.account) {
                return (app.user[`${label}`] = value)
              }
            }),
      },
    }
  },
  created: function() {
    return this.checkRole()
  },
  methods: {
    checkRole: function() {
      let ref
      if (!(app.user.角色 && app.user.角色.includes('管理员'))) {
        return router.push('/')
      }
    },
  },
}
</script>
